import { useQuery } from '@tanstack/react-query';
import { getContactOptions } from '../../lib/api/options';
import type { GetContactOptionsParams } from '../../lib/api/options';

export function useContactOptions(params: GetContactOptionsParams = {}, enabled = true) {
  return useQuery({
    queryKey: ['options', 'contacts', JSON.stringify(params)],
    queryFn: () => getContactOptions(params),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
